import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import Component from './components/AnchorNodeView';
import s from '../../components/Editor/styles/base.scss';
/**
 * Anchor extension
 *
 * Node extension that adds named anchors to the editor, in the editor we insert a + image of
 * anchor so the user can see them and delete them. Then in the viewer we render just the anchor.
 */ export const Anchor = Node.create({
    name: 'anchor',
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    addAttributes () {
        return {
            id: {
                default: null
            }
        };
    },
    inline: true,
    group: 'inline',
    draggable: true,
    parseHTML () {
        return [
            {
                tag: 'a[id]:not([href])'
            }
        ];
    },
    renderHTML ({ HTMLAttributes }) {
        return [
            'a',
            mergeAttributes(this.options.HTMLAttributes, _object_spread_props(_object_spread({}, HTMLAttributes), {
                contenteditable: false,
                class: s['anchor'],
                title: `Anchor ID: ${HTMLAttributes.id}`,
                'data-anchor': '1'
            }))
        ];
    },
    addNodeView () {
        return ReactNodeViewRenderer(Component);
    },
    renderText () {
        return '';
    },
    addCommands () {
        return {
            setAnchor: (id)=>({ commands })=>{
                    return commands.insertContent({
                        type: this.name,
                        attrs: {
                            id
                        }
                    });
                }
        };
    }
});

//# sourceMappingURL=anchor.js.map